<template>
  <router-view />
</template>

<script setup>
// 根组件：仅承载 router-view
// 登录态切换由路由守卫 + 各页面（Login/Layout）自行处理
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue',
    Arial, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}
</style>
